var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#4678bc}")), /*#__PURE__*/React.createElement("path", {
    d: "M3.43 23.94c0-3.47.01-6.94 0-10.41 0-1.05.5-1.75 1.39-2.26 2.14-1.23 4.26-2.49 6.4-3.73 2.22-1.29 4.45-2.57 6.67-3.86 1.51-.87 3.04-1.72 4.52-2.64.99-.61 1.92-.58 2.89-.02 3.59 2.08 7.17 4.16 10.76 6.24 2.36 1.38 4.73 2.76 7.08 4.15.84.49 1.22 1.27 1.22 2.23.01 6.89.01 13.78 0 20.66 0 .97-.46 1.72-1.28 2.2-3.19 1.89-6.4 3.75-9.61 5.62-2.74 1.6-5.49 3.17-8.23 4.78-1.14.67-2.15.38-3.2-.25-2.65-1.59-5.33-3.11-8-4.67-2.6-1.51-5.19-3.02-7.78-4.54-.71-.41-1.43-.82-2.08-1.31-.55-.41-.74-1.04-.74-1.74 0-3.48-.01-6.97-.01-10.45zm22.03-11.71c-2.55 0-5.01-.06-7.46.02-1.62.06-2.87 1.42-2.86 3.09.03 5.79.03 11.59 0 17.38-.01 1.51 1.39 2.96 2.94 2.95 3.89-.01 7.78 0 11.67 0 1.66 0 3-1.35 3-3.02V20.07c0-.18-.02-.35-.03-.56h-5.76c-1.01 0-1.5-.5-1.5-1.53v-5.75zm1.38.21c.01-.03-.02.03-.02.09 0 1.75 0 3.5-.01 5.25 0 .39.23.37.49.37h4.94c.13 0 .27-.03.28-.03l-5.68-5.68z",
    style: {
      fill: "#d0e0f3"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.46 12.23v5.75c0 1.03.49 1.53 1.5 1.53h5.76c.01.21.03.39.03.56v12.58c0 1.67-1.34 3.02-3 3.02H18.08c-1.55 0-2.95-1.45-2.94-2.95.03-5.79.03-11.59 0-17.38-.01-1.67 1.24-3.03 2.86-3.09 2.46-.09 4.92-.02 7.46-.02z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.84 12.44 5.68 5.68c-.01 0-.14.03-.28.03H27.3c-.27 0-.5.02-.49-.37.01-1.75.01-3.5.01-5.25-.01-.06.03-.12.02-.09z",
    className: "st1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemos);
export default __webpack_public_path__ + "static/media/memos.7e15875fc0b3aab305a3a0d97d05f2d2.svg";
export { ForwardRef as ReactComponent };